import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4fd00c46"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  style: {"display":"none"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("symbol", {
  id: "info-fill",
  fill: "currentColor",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" })
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "bi flex-shrink-0 me-2",
    width: "24",
    height: "24",
    role: "img",
    "aria-label": "Info:"
  }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#info-fill" })
  ])
], -1))
const _hoisted_5 = { class: "ms-1 me-1 flex-grow-1" }
const _hoisted_6 = { key: 0 }

import { withDefaults } from 'vue';

// Define props
interface Props {
  active?: boolean;
  hidden?: boolean;
  closeable?: boolean;
}

// Set default values for props

export default /*#__PURE__*/_defineComponent({
  __name: 'InfoModal',
  props: {
    active: { type: Boolean, default: true },
    hidden: { type: Boolean, default: false },
    closeable: { type: Boolean, default: false }
  },
  emits: ['reset'],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3)),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (__props.active || __props.hidden)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["alert alert-info p-2 mt-1 mb-1 d-flex align-items-start sticky-top", __props.hidden ? 'hide' : '']),
              role: "alert"
            }, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _renderSlot(_ctx.$slots, "default")
              ]),
              (__props.closeable)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn-close",
                      "aria-label": "Close",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('reset')))
                    })
                  ]))
                : _createCommentVNode("", true)
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ], 64))
}
}

})